import requestMaker from "lib";

export const getPredictedMeasurements = (params) => {
    const baseQuery = `/proxy/prv/ts/gpm`;
    return requestMaker(baseQuery, { params, payload: {} });
}